import { createAsyncThunk, createReducer, createAction } from '@reduxjs/toolkit'
import { API } from '../../constants'
import { application } from '../../services/application'

export const INITIAL_STATE = {
  rolesList: [],
  capabilities: [],
  currentRole: {},
}

const getRolesList = createAsyncThunk('organizationRoles/getRoles', (params) => {
  return application.call(API.ORGANIZATION_ROLES.GET_ROLES, params)
})

function onGetRolesList(state, action) {
  const roles = action.payload?.success ? action.payload?.roles : []
  return Object.assign(state, {
    rolesList: roles,
    capabilities: action.payload?.capabilities || [],
  })
}

const updateRole = createAsyncThunk('organizationRoles/updateRole', (params) => {
  return application.call(API.ORGANIZATION_ROLES.UPDATE_ROLE, params)
})

const updatePermissions = createAsyncThunk(
  'organizationRoles/updateRolePermissions',
  (params) => {
    return application.call(API.ORGANIZATION_ROLES.UPDATE_PERMISSIONS, params)
  }
)

const setRoleToEdit = createAction('organizationRoles/setRoleToEdit')

function onSetRoleToEdit(state, action) {
  return Object.assign(state, {
    currentRole: action.payload,
  })
}

export const actions = {
  getRolesList,
  setRoleToEdit,
  updateRole,
  updatePermissions,
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(getRolesList.fulfilled, onGetRolesList)
    .addCase(setRoleToEdit, onSetRoleToEdit)
})
